import axios from "axios";
import { headers } from "../../config";
import { baseUrl } from "./../../config/endpoints";
import store from './../../store';

function createAxios() {
    const instance = axios.create({
        baseURL: `${baseUrl}/stock`,
        headers: headers(),
    });

    // Add a request interceptor
    instance.interceptors.request.use(
        function(config) {
            // Do something before request is sent
            return config;
        },
        function(error) {
            // Do something with request error
            return Promise.reject(error);
        }
    );

    // Add a response interceptor
    instance.interceptors.response.use(
        function(response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data
            return response;
        },
        function(error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error

            if(error.response) {
                store.dispatch("ui/snackbar/show", { color: "error", text: error.response.data.message })
            } else {
                store.dispatch("ui/snackbar/show", { color: "error", text: error })
            }
           
            return Promise.reject(error);
        }
    );

    return instance;
}

export default createAxios;
